// extracted by mini-css-extract-plugin
export default {"container-section":"CalculatorContainer_container-section__-nbf3"};